var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.625 0C3.40625 0 3.22656 0.0703125 3.08594 0.210938C2.94531 0.351562 2.875 0.53125 2.875 0.75V1.125H0.625V1.875H1V7.875C1 8.17969 1.10938 8.44531 1.32812 8.67188C1.55469 8.89062 1.82031 9 2.125 9H6.625C6.92969 9 7.19141 8.89062 7.41016 8.67188C7.63672 8.44531 7.75 8.17969 7.75 7.875V1.875H8.125V1.125H5.875V0.75C5.875 0.53125 5.80469 0.351562 5.66406 0.210938C5.52344 0.0703125 5.34375 0 5.125 0H3.625ZM3.625 0.75H5.125V1.125H3.625V0.75ZM1.75 1.875H7V7.875C7 7.97656 6.96094 8.06641 6.88281 8.14453C6.8125 8.21484 6.72656 8.25 6.625 8.25H2.125C2.02344 8.25 1.93359 8.21484 1.85547 8.14453C1.78516 8.06641 1.75 7.97656 1.75 7.875V1.875ZM2.5 3V7.125H3.25V3H2.5ZM4 3V7.125H4.75V3H4ZM5.5 3V7.125H6.25V3H5.5Z",
    fill: "#089BAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconSmall);
export default __webpack_public_path__ + "static/media/trash-icon-small.8e22450b5707eb20238d04a281438c22.svg";
export { ForwardRef as ReactComponent };